/* eslint-disable */
export default [
  {
    id: 101,
    name: '单图链接',
    size: '370×245',
    style: '单图',
    subject: 1,
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 8,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 370,
            height: 245,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 36
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 105,
    name: '单图下载',
    size: '370×245',
    style: '单图',
    subject: 2,
    site: [
      {
        ftypes: 1,
        product: [1]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 370,
            height: 245,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 36
          }
        }
      },
      {
        name: 'subtitle',
        description: '副标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 24
          }
        }
      }
    ]
  },
  {
    id: 102,
    name: '三图链接①',
    size: '370×245',
    style: '多图',
    subject: 1,
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 3,
          max_number: 3
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 370,
            height: 245,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 104,
    name: '三图下载①',
    size: '370×245',
    style: '多图',
    subject: 2,
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 3,
          max_number: 3
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 370,
            height: 245,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'subtitle',
        description: '副标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 24
          }
        }
      }
    ]
  },
  {
    id: 221,
    name: '三图链接②',
    size: '220×220',
    style: '多图',
    subject: 1,
    site: [
      {
        ftypes: 2,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 3,
          max_number: 3
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 220,
            height: 220,
            file_size: 100,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 223,
    name: '三图下载②',
    size: '220×220',
    style: '多图',
    subject: 2,
    site: [
      {
        ftypes: 2,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 3,
          max_number: 3
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 220,
            height: 220,
            file_size: 100,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'subtitle',
        description: '副标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 24
          }
        }
      }
    ]
  },
  {
    id: 107,
    name: '大图链接',
    size: '1140×640',
    style: '大图',
    subject: 1,
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 2,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 8,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 1140,
            height: 640,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 106,
    name: '大图下载',
    size: '1140×640',
    style: '大图',
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 2,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 8,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 2,
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 1140,
            height: 640,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'subtitle',
        description: '副标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 24
          }
        }
      }
    ]
  },
  {
    id: 103,
    name: '小图视频链接',
    size: '1280×720',
    style: '视频(横版)',
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 524288,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 1,
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 370,
            height: 245,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'poster',
        description: '封面',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          image_restriction: {
            width: 750,
            height: 420,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'videoid',
        description: '视频',
        required: true,
        element_type: 'ELEMENT_TYPE_VIDEO',
        field_type: 'FIELD_TYPE_INTEGER',
        parent_name: '',
        restriction: {
          video_restriction: {
            width: 1280,
            height: 720,
            file_size: 204800,
            file_format: [
              'MEDIA_TYPE_MP4',
              'MEDIA_TYPE_MOV',
              'MEDIA_TYPE_AVI'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 36
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 108,
    name: '大图视频链接',
    size: '1280×720',
    style: '视频(横版)',
    site: [
      {
        ftypes: 1,
        product: [1, 2]
      }, {
        ftypes: 2,
        product: [1]
      }, {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 8,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 524288,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 1,
    material: [
      {
        name: 'poster',
        description: '封面',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          image_restriction: {
            width: 1140,
            height: 640,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'videoid',
        description: '视频',
        required: true,
        element_type: 'ELEMENT_TYPE_VIDEO',
        field_type: 'FIELD_TYPE_INTEGER',
        parent_name: '',
        restriction: {
          video_restriction: {
            width: 1280,
            height: 720,
            file_size: 204800,
            file_format: [
              'MEDIA_TYPE_MP4',
              'MEDIA_TYPE_MOV',
              'MEDIA_TYPE_AVI'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 109,
    name: '大图视频下载',
    size: '1280×720',
    style: '视频(横版)',
    site: [
      {
        ftypes: 1,
        product: [1]
      }, {
        ftypes: 2,
        product: [1]
      }, {
        ftypes: 8,
        product: [1, 2]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 524288,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 2,
    material: [
      {
        name: 'poster',
        description: '封面',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          image_restriction: {
            width: 1140,
            height: 640,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'videoid',
        description: '视频',
        required: true,
        element_type: 'ELEMENT_TYPE_VIDEO',
        field_type: 'FIELD_TYPE_INTEGER',
        parent_name: '',
        restriction: {
          video_restriction: {
            width: 1280,
            height: 720,
            file_size: 204800,
            file_format: [
              'MEDIA_TYPE_MP4',
              'MEDIA_TYPE_MOV',
              'MEDIA_TYPE_AVI'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'subtitle',
        description: '副标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 24
          }
        }
      }
    ]
  },
  {
    id: 111,
    name: '竖版视频链接',
    size: '720X1280',
    style: '视频(竖版)',
    site: [
      {
        ftypes: 1,
        product: [1]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 524288,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 1,
    material: [
      {
        name: 'poster',
        description: '封面',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          image_restriction: {
            width: 640,
            height: 1140,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'videoid',
        description: '视频',
        required: true,
        element_type: 'ELEMENT_TYPE_VIDEO',
        field_type: 'FIELD_TYPE_INTEGER',
        parent_name: '',
        restriction: {
          video_restriction: {
            width: 720,
            height: 1280,
            file_size: 204800,
            file_format: [
              'MEDIA_TYPE_MP4',
              'MEDIA_TYPE_MOV',
              'MEDIA_TYPE_AVI'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 112,
    name: '竖版视频下载',
    size: '720X1280',
    style: '视频(竖版)',
    site: [
      {
        ftypes: 1,
        product: [1]
      }, {
        ftypes: 65536,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }, {
        ftypes: 524288,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    subject: 2,
    material: [
      {
        name: 'poster',
        description: '封面',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          image_restriction: {
            width: 640,
            height: 1140,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'videoid',
        description: '视频',
        required: true,
        element_type: 'ELEMENT_TYPE_VIDEO',
        field_type: 'FIELD_TYPE_INTEGER',
        parent_name: '',
        restriction: {
          video_restriction: {
            width: 720,
            height: 1280,
            file_size: 204800,
            file_format: [
              'MEDIA_TYPE_MP4',
              'MEDIA_TYPE_MOV',
              'MEDIA_TYPE_AVI'
            ]
          }
        }
      },
      {
        name: 'title',
        description: '标题',
        required: true,
        element_type: 'ELEMENT_TYPE_TEXT',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 60
          }
        }
      }
    ]
  },
  {
    id: 401,
    name: '开屏链接',
    size: '640×960',
    style: '单图(竖版)',
    subject: 1,
    site: [
      {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 262144,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 640,
            height: 960,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 403,
    name: '开屏下载',
    size: '640×960',
    style: '单图',
    subject: 2,
    site: [
      {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 262144,
        product: [1, 2],
        leagueOpenFlag: [0, 1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 640,
            height: 960,
            file_size: 500,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      }
    ]
  },
  {
    id: 402,
    name: '横幅链接',
    size: '800×120',
    style: '单图',
    subject: 1,
    site: [
      {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 800,
            height: 120,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      },
      {
        name: 'url',
        description: '落地页URL',
        required: true,
        element_type: 'ELEMENT_TYPE_URL',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: '',
        restriction: {
          text_restriction: {
            min_length: 1,
            max_length: 1024,
            text_pattern: '^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+'
          }
        }
      }
    ]
  },
  {
    id: 404,
    name: '横幅下载',
    size: '800×120',
    style: '单图',
    subject: 2,
    site: [
      {
        ftypes: 4,
        product: [1, 2]
      }, {
        ftypes: 131072,
        product: [1, 2],
        leagueOpenFlag: [1]
      }
    ],
    material: [
      {
        name: 'pictures',
        description: '素材',
        required: false,
        array_property: {
          min_number: 1,
          max_number: 1
        },
        element_type: 'ELEMENT_TYPE_STRUCT',
        field_type: 'FIELD_TYPE_STRUCT_ARRAY',
        parent_name: '',
        restriction: {}
      },
      {
        name: 'imageid',
        description: '单图',
        required: true,
        element_type: 'ELEMENT_TYPE_IMAGE',
        field_type: 'FIELD_TYPE_STRING',
        parent_name: 'pictures',
        restriction: {
          image_restriction: {
            width: 800,
            height: 120,
            file_size: 200,
            file_format: [
              'IMAGE_TYPE_JPG',
              'IMAGE_TYPE_PNG'
            ]
          }
        }
      }
    ]
  }
]
